import React from 'react';

const Hero = props => {
  return (
    <section className="hero"></section>
  );
}

export default Hero;